import React from 'react';
import { motion } from 'framer-motion';
import { JaliDivider } from './JaliDivider';
import { useLanguage } from '../lib/LanguageContext';
export function FoundingCircle() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 bg-navy relative overflow-hidden" id="founding" data-id="element-49">
      {/* Decorative corners */}
      <div className="absolute top-0 left-0 w-32 h-32 border-t border-l border-gold/20 opacity-50 m-8" data-id="element-50" />
      <div className="absolute bottom-0 right-0 w-32 h-32 border-b border-r border-gold/20 opacity-50 m-8" data-id="element-51" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} data-id="element-53">
          <JaliDivider className="mb-8" data-id="element-54" />

          <h2 className="text-4xl md:text-6xl font-heading text-warmWhite mb-8" data-id="element-55">
            {t('foundingCircle.title1')}{' '}
            <span className="text-saffron italic" data-id="element-56">
              {t('foundingCircle.title2')}
            </span>
          </h2>

          <p className="text-warmWhite/80 text-xl md:text-2xl font-light leading-relaxed mb-12 max-w-2xl mx-auto text-balance" data-id="element-57">
            {t('foundingCircle.description')}
          </p>

          <button className="px-10 py-5 bg-saffron text-navy rounded-sm text-sm tracking-widest uppercase font-semibold hover:bg-warmWhite transition-colors duration-300 shadow-lg hover:shadow-xl" data-id="element-58">
            {t('foundingCircle.cta')}
          </button>

          <JaliDivider className="mt-16" data-id="element-59" />
        </motion.div>
      </div>
    </section>;
}